import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/Home/HomePage';
import Dashboard from './pages/Dashboard/Dashboard';
import UserDashboard from './pages/UserDashboard/UserDashboard';
import TopicDetail from './pages/TopicDetail/TopicDetail';
import AnalysisPage from './pages/Analysis/AnalysisPage';
import PrivateRoute from './components/Auth/PrivateRoute';
import LoginPage from './pages/Auth/LoginPage';
import RegisterPage from './pages/Auth/RegisterPage';
import ForgotPasswordPage from './pages/Auth/ForgotPasswordPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          
          <Route path="/dashboard" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          
          <Route path="/user-dashboard" element={
            <PrivateRoute>
              <UserDashboard />
            </PrivateRoute>
          } />

          <Route path="/user-dashboard/topics" element={
            <PrivateRoute>
              <UserDashboard />
            </PrivateRoute>
          } />

          <Route path="/user-dashboard/profile" element={
            <PrivateRoute>
              <UserDashboard />
            </PrivateRoute>
          } />
          
          <Route path="/topic/:id" element={
            <PrivateRoute>
              <TopicDetail />
            </PrivateRoute>
          } />

          <Route path="/analysis" element={
            <PrivateRoute>
              <AnalysisPage />
            </PrivateRoute>
          } />
          
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;